import styled from 'styled-components/macro'

import uImage from '../../assets/images/big_unicorn.png'
import noise from '../../assets/images/noise.png'
import xlUnicorn from '../../assets/images/xl_uni.png'
import { AutoColumn } from '../Column'

export const DataCard = styled(AutoColumn)<{ disabled?: boolean }>`
  // background-color: #686969;
  // border-radius: 5px;
  width: 100%;
  position: relative;
  overflow: hidden;
  text-align: center;
  line-height: 1.5;
  display: inline-block;
  vertical-align: middle;
`
// export const DataCard = styled(AutoColumn)<{ disabled?: boolean }>`
//   background: radial-gradient(76.02% 75.41% at 1.84% 0%, #ff007a 0%, #2172e5 100%);
//   border-radius: 5px;
//   width: 100%;
//   position: relative;
//   overflow: hidden;
//   text-align: center;
//   line-height: 1.5;
//   display: inline-block;
//   vertical-align: middle;
// `
export const CardBGImage = styled.span<{ desaturate?: boolean }>`
  background: url(${uImage});
  width: 1000px;
  height: 600px;
  position: absolute;
  border-radius: 0px;
  opacity: 0;
  top: -100px;
  left: -100px;
  transform: rotate(0deg);
  user-select: none;
  ${({ desaturate }) => desaturate && `filter: grayscale(100%)`}
`

export const CardBGImageSmaller = styled.span<{ desaturate?: boolean }>`
  background: url(${xlUnicorn});
  width: 1200px;
  height: 1200px;
  position: absolute;
  border-radius: 12px;
  top: -300px;
  left: -300px;
  opacity: 0;
  user-select: none;

  ${({ desaturate }) => desaturate && `filter: saturate(0)`}
`

export const CardNoise = styled.span`
  background: url(${noise});
  background-size: auto;
  border-radius: 0px;
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
`

export const CardSection = styled(AutoColumn)<{ disabled?: boolean }>`
  padding: 1rem;
  z-index: 1;
  opacity: ${({ disabled }) => disabled && '0.4'};
`

export const Break = styled.div`
  width: 100%;
  background-color: rgba(255, 255, 255, 0.2);
  height: 1px;
`
